import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';

const ContactForm = () => {
  const [responseMessage, setResponseMessage] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    first_name: false,
    last_name: false,
    email: false,
    message: false
  });
  const [data, setData] = useState({
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      message: '',
      reference: ''
  });

  // Format phone number as (###) ###-####
  const formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const phoneNumber = value.replace(/\D/g, '');
    
    // Apply formatting based on length
    if (phoneNumber.length < 4) {
      return phoneNumber;
    } else if (phoneNumber.length < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    } else {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    }
  };

  // Handle phone input with formatting
  const handlePhoneChange = (e) => {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    setData({...data, phone: formattedPhoneNumber});
  };

  // Handle input change and clear validation errors
  const handleInputChange = (field, value) => {
    setData({...data, [field]: value});
    if (validationErrors[field]) {
      setValidationErrors({...validationErrors, [field]: false});
    }
  };


  // Reset form to allow another submission
  const handleReset = () => {
    setIsSubmitted(false);
    setResponseMessage('');
    setValidationErrors({
      first_name: false,
      last_name: false,
      email: false,
      message: false
    });
  };


  return (
    <div>
      {isSubmitted ? (
        <div className="px-6 pb-24 pt-20 sm:pb-32 lg:px-8 lg:py-48">
          <div className="mx-auto max-w-xl lg:mr-0 lg:max-w-lg text-center">
            <div className="rounded-lg bg-green-50 p-6 mb-6">
              <div className="flex items-center justify-center">
                <svg className="h-10 w-10 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              <h3 className="mt-3 text-lg font-medium text-green-800">Message Sent Successfully!</h3>
              <p className="mt-2 text-base text-green-700">{responseMessage}</p>
            </div>
            
            <Link
              to="/"
              onClick={handleReset}
              className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              &larr; Back to Home
            </Link>
          </div>
        </div>
      ) : (
        <Formik
       initialValues={{ email: '', password: '' }}
       validate={values => {
         const errors = {};
         if (!values.email) {
           errors.email = 'Required';
         } else if (
           !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
         ) {
           errors.email = 'Invalid email address';
         }
         return errors;
       }}
       onSubmit={(values, { setSubmitting }) => {
         setTimeout(() => {
           alert(JSON.stringify(values, null, 2));
           setSubmitting(false);
         }, 400);
       }}
     >
       {({
         values,
         errors,
         touched,
         handleChange,
         handleBlur,
         handleSubmit,
         isSubmitting,
         /* and other goodies */
       }) => (
        <form className="px-6 pb-24 pt-20 sm:pb-32 lg:px-8 lg:py-48"
          //onSubmit={handleSubmit}
        >
          <div className="mx-auto max-w-xl lg:mr-0 lg:max-w-lg">
            {responseMessage && (
              <div className="mb-4 p-3 rounded-md bg-red-50 text-red-700">
                {responseMessage}
              </div>
            )}
              
            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
              <div>
                <label htmlFor="first-name" className="block text-sm font-semibold leading-6 text-gray-900">
                  First name <span className="text-red-500">*</span>
                </label>
                <div className="mt-2.5">
                  <input
                    disabled
                    id="first-name"
                    name="first-name"
                    required
                    minLength={2}
                    type="text"
                    autoComplete="given-name"
                    value={data.first_name}
                    onChange={(e) => handleInputChange('first_name', e.target.value)}
                    className={`block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ${validationErrors.first_name ? 'ring-red-500' : 'ring-gray-300'} placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                  />
                  {validationErrors.first_name && (
                    <p className="mt-1 text-sm text-red-600">First name is required</p>
                  )}
                </div>
              </div>
              <div>
                <label htmlFor="last-name" className="block text-sm font-semibold leading-6 text-gray-900">
                  Last name <span className="text-red-500">*</span>
                </label>
                <div className="mt-2.5">
                  <input
                    disabled
                    id="last-name"
                    name="last-name"
                    required
                    minLength={2}
                    type="text"
                    autoComplete="family-name"
                    value={data.last_name}
                    onChange={(e) => handleInputChange('last_name', e.target.value)}
                    className={`block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ${validationErrors.last_name ? 'ring-red-500' : 'ring-gray-300'} placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                  />
                  {validationErrors.last_name && (
                    <p className="mt-1 text-sm text-red-600">Last name is required</p>
                  )}
                </div>
              </div>
              <div className="sm:col-span-2">
                <label htmlFor="email" className="block text-sm font-semibold leading-6 text-gray-900">
                  Email <span className="text-red-500">*</span>
                </label>
                <div className="mt-2.5">
                  <input
                    disabled
                    id="email"
                    name="email"
                    required
                    type="email"
                    autoComplete="email"
                    value={data.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    className={`block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ${validationErrors.email ? 'ring-red-500' : 'ring-gray-300'} placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                  />
                  {validationErrors.email && (
                    <p className="mt-1 text-sm text-red-600">Email is required</p>
                  )}
                </div>
              </div>
              <div className="sm:col-span-2">
                <label htmlFor="phone-number" className="block text-sm font-semibold leading-6 text-gray-900">
                  Phone number
                </label>
                <div className="mt-2.5">
                  <input
                    disabled
                    id="phone-number"
                    name="phone-number"
                    type="tel"
                    autoComplete="tel"
                    maxLength={14}
                    placeholder="(555) 555-5555"
                    value={data.phone}
                    onChange={handlePhoneChange}
                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
              <div className="sm:col-span-2">
                <label htmlFor="message" className="block text-sm font-semibold leading-6 text-gray-900">
                  Message <span className="text-red-500">*</span>
                </label>
                <div className="mt-2.5">
                  <textarea
                    disabled
                    id="message"
                    name="message"
                    required
                    rows={4}
                    value={data.message}
                    onChange={(e) => handleInputChange('message', e.target.value)}
                    maxLength={2000}
                    className={`block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ${validationErrors.message ? 'ring-red-500' : 'ring-gray-300'} placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                  />
                  {validationErrors.message && (
                    <p className="mt-1 text-sm text-red-600">Message is required</p>
                  )}
                </div>
              </div>
            </div>
            <div className='text-sm italic text-gray-600 mt-4'>
              By submitting my contact information I agree to receive communications from the dealership and the dealership's agent(s). If I include my phone number, I agree to receive calls and text messages (including via automation). Standard message and data rates may apply. I can opt out at any time. This consent is not required as a condition of purchase. Message frequency may vary. See our Privacy Policy for more information.
            </div>
            <div className="mt-8 flex justify-end">
              <button
                disabled
                type="submit"
                className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-base font-semibold rounded-md text-white bg-red-300 hover:bg-red-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                Send Message
              </button>
            </div>
          </div>
        </form>
        )}
     </Formik>
      )}
    </div>
  );
};

export default ContactForm;